const renderingRobReducerDefaultState = {
  text: 'Rob is thinking...'
};

const renderingRobReducer = (
  state = renderingRobReducerDefaultState,
  action
) => {
  switch (action.type) {
    case 'SET_RENDERING_ROB':
      return {
        ...state,
        text: action.text
      };
    default:
      return state;
  }
};

export default renderingRobReducer;
